{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              18.500143076273844,
              42.40903980470031
            ],
            [
              18.83613536772188,
              42.05754635019065
            ],
            [
              19.372505455741845,
              41.851226165477925
            ],
            [
              19.403312175606573,
              42.10332215025679
            ],
            [
              19.282995962414816,
              42.18113094250259
            ],
            [
              19.341673177219008,
              42.22440929532945
            ],
            [
              19.542885770169136,
              42.49136030442628
            ],
            [
              18.534641714983906,
              42.938728875436425
            ],
            [
              18.574529067064702,
              42.72445151743608
            ],
            [
              18.442249076307178,
              42.55013740446773
            ],
            [
              18.500143076273844,
              42.40903980470031
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}